import { z } from "zod";

const BrowseEntitiesSchema = z
  .object({
    id: z.string().uuid({ message: "Id is required." }),
    search: z.string(),
    page: z.number().min(1, { message: "Page is out of bounds" }),
  })
  .strict();

export default BrowseEntitiesSchema;
